/**
 * Política de contraseñas del frontend — espejo de
 * `backend/src/utils/passwordPolicy.js`.
 *
 * Round 2026-07-27. El número estaba copiado en varias pantallas con valores
 * distintos (la de reseteo pedía 8, el perfil 6) y el backend aceptaba 6
 * mientras la documentación de la API prometía 8. Ahora hay una sola constante
 * por lado y ambos dicen 8.
 *
 * IMPORTANTE: esto valida contraseñas NUEVAS. El formulario de **inicio de
 * sesión** no debe usarlo: quien ya tenga una contraseña más corta —creada
 * cuando el mínimo era menor— seguiría pudiendo entrar, y exigirle 8 para
 * tipear la suya lo dejaría fuera de su propia cuenta.
 */
export const MIN_PASSWORD_LENGTH = 8;

/** Regla de AntD `Form.Item` para un campo de contraseña nueva. */
export const passwordMinRule = {
  min: MIN_PASSWORD_LENGTH,
  message: `Mínimo ${MIN_PASSWORD_LENGTH} caracteres`,
};
